import React from "react";
import { Route, Redirect, withRouter } from "react-router-dom";
import {
  canAccessNavLink,
  getFirstAccessibleRoute,
  getStoredActiveNavLinks,
} from "../navigation";

const Authmiddleware = ({
  component: Component,
  layout: Layout,
  activeNavLink,
}) => (
  <Route
    render={(props) => {
      // if not logged in, redirect to login page

      const token = localStorage.getItem("JWT");
      const storedActiveNavLinks = localStorage.getItem("activeNaviLinks");

      if (!token || storedActiveNavLinks === null) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }

      const activeNavLinks = getStoredActiveNavLinks();

      if (!canAccessNavLink(activeNavLinks, activeNavLink)) {
        const fallbackRoute = getFirstAccessibleRoute(activeNavLinks);
        return <Redirect to={fallbackRoute || "/unauthorized"} />;
      }
      return (
        <Layout>
          <Component {...props} />
        </Layout>
      );
    }}
  />
);

export default withRouter(Authmiddleware);
